import TapIntoCCommerceBanner from "app/components/banners/tap-into-ccommerce";
import { MerchantList } from "app/components/who-we-serve/merchant-list";
import { Trans } from "react-i18next";

export const SeeHowCCommerceSection = () => {
  return (
    <section className="bg-ghostwhite font-montserrat text-base text-primary">
      <div className="zbooni-layout relative">
        <div>
          <p className="mx-auto max-w-xs pt-20 text-center text-[20px] font-extrabold leading-7 md:max-w-xl md:text-[33px] md:leading-10">
            <Trans>See how cCommerce is enabling businesses like yours.</Trans>
          </p>
          <div className="pt-10">
            <MerchantList />
          </div>
        </div>
        <div className="py-10 sm:py-12 lg:py-16">
          <TapIntoCCommerceBanner />
        </div>
      </div>
    </section>
  );
};
